var Marionette = require('backbone.marionette');
var LedgerCodeCollection = require('../collections/ledger');

var LedgerCodeItem = Marionette.ItemView.extend({
  template(model){
    if(model == undefined){
      return '---------';
    }
    return model['code'] + ' ' + model['name'];
  },

  tagName: 'option',

  attributes(){
    return {
      value: this.model.get('id')
    };
  }
});

var LedgerCodeList = Marionette.CompositeView.extend({
  template: require('../templates/ledger.html'),
  childViewContainer: 'select',
  childView: LedgerCodeItem,
  attribute: 'ledger',

  tryRender(){
    try{
      this.render();
    } catch(e){} // eslint-disable-line no-empty
    // Throw away error, it's not essential
  },

  collectionEvents: {
    sync: 'render'
  },

  modelEvents: {
    sync: 'tryRender'
  },

  ui: {
    select: 'select'
  },

  triggers: {
    'change @ui.select': 'set'
  },

  constructor() {
    this.collection = new LedgerCodeCollection();
    Marionette.CompositeView.prototype.constructor.apply(this, arguments);
    this.collection.fetch();
  },

  onRender(){
    this.ui.select.val(this.model.get(this.attribute));
  },

  onSet(){
    this.model.set(this.attribute, this.ui.select.val());
  }
});

module.exports = LedgerCodeList;



// WEBPACK FOOTER //
// ./base/views/ledger.js